import { memo } from 'react'

const ComputerIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox='0 0 24 24'
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.91 21a.86.86 0 0 1-.648-.272.937.937 0 0 1-.262-.673c0-.266.087-.49.262-.672a.865.865 0 0 1 .647-.272h18.182c.258 0 .473.09.648.272a.929.929 0 0 1 .261.672.94.94 0 0 1-.262.674.853.853 0 0 1-.647.271H2.909Zm1.817-2.833c-.5 0-.928-.185-1.283-.555a1.859 1.859 0 0 1-.535-1.334V5.888c0-.519.178-.963.535-1.333.356-.37.784-.554 1.283-.555h14.546c.5 0 .928.185 1.284.555.357.37.535.815.534 1.334v10.389c0 .52-.178.964-.534 1.334-.355.37-.784.555-1.284.555H4.727Zm0-1.89h14.546V5.89H4.727v10.389Z"
    />
  </svg>
)

export default memo(ComputerIcon)
